import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Buttons/Button";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import { getUserInfo, getUserRolePermissions, getUsers } from 'src/services/userServicer';
import Select from 'react-select';
import { getControls } from "src/services/controls";
import { useForm } from "react-hook-form";
import { MdOutlineDelete } from "react-icons/md";
import { createSurvey, fetchAllDataApi, fetchQuestionByReference } from "src/services/question"
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import i18n from "src/i18n";
import { getReferences } from "src/services/reference";
const CreateSurvey = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notAllowed, setNotAllowed] = useState(false);
  const [userPermissions, setUserPermissions] = useState<any>(null);

  const { register, handleSubmit, formState: { errors }, watch, setValue, trigger } = useForm();
  const [question, setQuestion] = useState({
    en_name: '',
    ar_name: '',
    en_description: '',
    ar_description: '',
    questions: [],
    users: []
  });

  const [usersOptions, setUsersOptions] = useState<any[]>([]);
  const [questionsOptions, setQuestionsOptions] = useState<any[]>([]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setQuestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


 

  const onSubmit = async(data: any) => {
    const response = await createSurvey(question);
    if (response.success) {
      toast.success(response.message);
      navigate('/surveys');
    } else {
      toast.error(response.message);
    }
    
  };


  const fetchUsers = async () => {
    try {
      const response: any = await getUsers("", 10000, 0);
       
      if (response && response.success) {
        const indexedData = response.data.map((user: any, idx: number) => ({
          value: user.id,
          label: user.name
        }));
        setUsersOptions(indexedData); 
      } else if (response && response.data.length === 0) {
        setUsersOptions([]);
        
      } else {
        toast.error("Failed to fetch users data");
      }
    } catch (error: any) {
      toast.error("Error fetching users data:", error);
    }
  };

  const fetchQuestions = async () => {
    try {
      const questions: any = await fetchAllDataApi();
      
        if (questions.success) {
        let questionsOptions = questions.data.map((question: any) => ({
          value: question.id,
          label: i18n.language === 'ar' ? question.question_ar : question.question_en
        }));
        setQuestionsOptions(questionsOptions);
      } else {
        toast.error(questions.message);
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

 


  useEffect(() => {
    const fetchUserRolePermissions = async () => {
      try {
        const user = await getUserInfo();
        if (!user?.id) {
          setNotAllowed(true);
          return;
        }
        let userId =  user.id || "";
        const permissions = await getUserRolePermissions(userId);
        if (permissions.success) {
          // Check for survey permission first, fallback to compliances
          const surveyPagePermission = permissions.data.permissions.find((permission: any) => permission.page === "survey");
          const compliancePagePermission = permissions.data.permissions.find((permission: any) => permission.page === "compliances");
          const pagePermission = surveyPagePermission || compliancePagePermission;
          
          if (pagePermission) {
            setUserPermissions(pagePermission.permissions || pagePermission);
            const hasShowPermission = (pagePermission.permissions?.show ?? pagePermission.show) ?? true;
            const hasCreatePermission = (pagePermission.permissions?.create ?? pagePermission.create) ?? true;
            if (hasShowPermission && hasCreatePermission) {
              setNotAllowed(false);
            } else {
              setNotAllowed(true);
            }
          } else {
            // If no specific permission found, allow access (fallback behavior)
            setNotAllowed(false);
          }
        } else {
          toast.error(permissions.message || t("permissions.Error_fetching_user_role_permissions"));
          setNotAllowed(true);
        }
      } catch (error: any) {
        const errorMessage = error?.message || error?.toString() || t("permissions.Error_fetching_user_role_permissions");
        toast.error(t("permissions.Error_fetching_user_role_permissions") + ": " + errorMessage);
        setNotAllowed(true);
      }
    };

    fetchUserRolePermissions();
    fetchUsers();
    fetchQuestions();
  }, []);

  // Custom styles for react-select to reduce height
  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '50px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '40px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '40px',
    }),
  };

  return (
    <div className="root">
      <Breadcrumb>
        <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
        <BreadcrumbItem>{t("surveys.Surveys")}</BreadcrumbItem>
        <BreadcrumbItem active style={{ paddingRight: '10px' }}>
          {t("surveys.Create Survey")}
        </BreadcrumbItem>
      </Breadcrumb>

      <h5 className="mb-lg">{t('surveys.Create Survey')}</h5>
      {!notAllowed && <div className="container_info">
        <form onSubmit={handleSubmit(onSubmit)} className="create-compliance-form">
          <div className="form-section2 mb-5">
            <h5 className="section-title">{t('surveys.BasicInfo')}</h5>
            <div className="form-group">
              <label>{t('surveys.NameEn')}</label>
              <input
                type="text"
                value={question.en_name}
                placeholder={t('surveys.NameEnPlaceholder') || ''}
                className="form-control"
                {...register("en_name", { required: true })}
                onChange={handleInputChange}
              />
              {errors.en_name && <span className="text-danger">{t('surveys.This field is required')}</span>}
            </div>
            <div className="form-group">
              <label>{t('surveys.NameAr')}</label>
              <input
                type="text"
                value={question.ar_name}
                placeholder={t('surveys.NameArPlaceholder') || ''}
                className="form-control"
                {...register("ar_name", { required: true })}
                onChange={handleInputChange}
              />
              {errors.ar_name && <span className="text-danger">{t('surveys.This field is required')}</span>}
            </div>
            <div className="form-group">
              <label>{t('surveys.en_description')}</label>
              <input
                type="text"
                value={question.en_description}
                placeholder={t('surveys.en_description_placeholder') || ''}
                className="form-control"
                {...register("en_description", { required: true })}
                onChange={handleInputChange}
              />
              {errors.en_description && <span className="text-danger">{t('surveys.This field is required')}</span>}
            </div>
            <div className="form-group">
              <label>{t('surveys.ar_description')}</label>
              <input
                type="text"
                value={question.ar_description}
                placeholder={t('surveys.ar_description_placeholder') || ''}
                className="form-control"
                {...register("ar_description", { required: true })}
                onChange={handleInputChange}
              />
              {errors.ar_description && <span className="text-danger">{t('surveys.This field is required')}</span>}
            </div>

            

           

        
          </div>

          <div className="form-section2 mb-5">
            <h5 className="section-title">{t('surveys.questions')}</h5>

            <div className="form-group">
              <label className="form-label">{t("surveys.questions")}</label>
              <Select
                options={questionsOptions}
                isMulti={true}
                className="basic-single"
                classNamePrefix="select"
                styles={customSelectStyles}
                {...register("questions")}
                onChange={(selectedOptions: any) => {
                  setQuestion((prev) => ({
                    ...prev,
                    questions: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                  }));
                  setValue("questions", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                  trigger("questions");
                }}
              />
            </div>

          </div>

          <div className="form-section2 mb-5">
            <h5 className="section-title">{t('surveys.users')}</h5>


            <div className="form-group">
              <label className="form-label">{t("surveys.users")}</label>
              <Select
                options={usersOptions}
                isMulti={true}
                className="basic-single"
                classNamePrefix="select"
                styles={customSelectStyles}
                {...register("users")}
                onChange={(selectedOptions: any) => {
                  setQuestion((prev) => ({
                    ...prev,
                    users: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                  }));
                  setValue("users", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                  trigger("users");
                }}
              />
            </div>
            <button type="submit" className="submit-button4">
              {t("surveys.Create Survey")}
            </button>
          </div>
        </form>
      </div>}

      {notAllowed && <div className="container_info">
        <div className="d-flex justify-content-between my-2 text-center alert alert-danger">
          <h5 style={{ width: '100%' }} className="text-center">{t("permissions.not_allowed")}</h5>
        </div>
      </div>}
    </div>
  );
};

export default CreateSurvey;